import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useCallback } from "react";
const LayoutContext = createContext(null);
export function LayoutProvider({ children }) {
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [isSidebarVisible, setIsSidebarVisible] = useState(true);
    const [isDense, setIsDense] = useState(false);
    const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);
    const toggleFullScreen = useCallback(() => {
        setIsFullScreen((prev) => {
            const newValue = !prev;
            setIsSidebarVisible(!newValue);
            return newValue;
        });
    }, []);
    const exitFullScreen = useCallback(() => {
        setIsFullScreen(false);
        setIsSidebarVisible(true);
    }, []);
    const toggleDensity = () => setIsDense(prev => !prev);
    return (_jsx(LayoutContext.Provider, { value: {
            isFullScreen,
            isSidebarVisible,
            toggleFullScreen,
            exitFullScreen,
            isDense,
            toggleDensity,
            isSidebarExpanded,
            setIsSidebarExpanded
        }, children: children }));
}
export function useLayout() {
    const context = useContext(LayoutContext);
    if (!context) {
        throw new Error("useLayout must be used within LayoutProvider");
    }
    return context;
}
